export class KeyboardManager {
    // MultiNostalgia patch: writes the owning Gameboy's Input instance
    // (was a shared module singleton).
    input;
    down = 'ArrowDown';
    up = 'ArrowUp';
    left = 'ArrowLeft';
    right = 'ArrowRight';
    a = 'KeyA';
    b = 'KeyB';
    start = 'Enter';
    select = 'ControlRight';
    constructor(input) {
        this.input = input;
        // MultiNostalgia patch: the vendor singleton used to attach global
        // document keydown/keyup listeners here. We DON'T — input is owned
        // entirely by the host, which routes through the core adapter's
        // buttonDown()/buttonUp() (core-base.ts) into the same `input`
        // singleton these handlers would have written. The global listeners
        // were not just redundant; they fired for EVERY document keystroke,
        // bypassing the player's InputHub (editable-target guard, per-tile
        // demux, rebindable keys). That meant typing into an unrelated text
        // field — e.g. a devtools rename modal — drove the emulator. The
        // singleton itself is still constructed (gameboy.ts holds it as a
        // field, and at module load in Node), it simply listens to nothing.
        // handleKeyEvent is retained so a host that wants the vendor's
        // default keymap can opt in by calling it explicitly.
    }
    handleKeyEvent(keyCode, isPressed) {
        if (keyCode === this.down) {
            this.input.isPressingDown = isPressed;
        }
        if (keyCode === this.up) {
            this.input.isPressingUp = isPressed;
        }
        if (keyCode === this.left) {
            this.input.isPressingLeft = isPressed;
        }
        if (keyCode === this.right) {
            this.input.isPressingRight = isPressed;
        }
        if (keyCode === this.a) {
            this.input.isPressingA = isPressed;
        }
        if (keyCode === this.b) {
            this.input.isPressingB = isPressed;
        }
        if (keyCode === this.start) {
            this.input.isPressingStart = isPressed;
        }
        if (keyCode === this.select) {
            this.input.isPressingSelect = isPressed;
        }
    }
}
//# sourceMappingURL=keyboard-manager.js.map